/**
 * 轻提示(Toast)状态(_shared C-6)。zustand 存瞬时提示,由 <Toaster/>(挂在 AppLayout)渲染。
 * 成功/可恢复错误用吐司;阻断性决策仍走对话框(C-5),不降级为吐司。
 * 非 React 上下文(提交回调)经模块级 `toast.success/error/info` 推入。
 */
import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'info';

export interface ToastItem {
  id: number;
  type: ToastType;
  message: string;
}

interface ToastState {
  toasts: ToastItem[];
  push: (type: ToastType, message: string) => void;
  remove: (id: number) => void;
}

let seq = 0;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (type, message) => {
    seq += 1;
    const id = seq;
    set((s) => ({ toasts: [...s.toasts, { id, type, message }] }));
  },
  remove: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

export const toast = {
  success: (message: string) => useToastStore.getState().push('success', message),
  error: (message: string) => useToastStore.getState().push('error', message),
  info: (message: string) => useToastStore.getState().push('info', message),
};
